module.exports = __webpack_public_path__ + "media/132.5ecd5057.wav";